import React, { useEffect, useState } from "react";
import {
    AppBar,
    Toolbar,
    Box,
    IconButton,
    useMediaQuery,
    Drawer,
    Container,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocation, Link, useNavigate } from "react-router-dom";
import logo from '../../assets/logo.png';
import { IoCallOutline } from "react-icons/io5";
import { FaInstagram } from "react-icons/fa";
import { AiOutlineMenu } from "react-icons/ai";
import { getContactUS } from "../../services/ConatactUs";
import { useMediaQueries } from "../../usecontext/UseProvider";
import { LiaFacebookSquare } from "react-icons/lia";
import { PiWhatsappLogo } from "react-icons/pi";

const Header = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [drawerOpen, setDrawerOpen] = useState(false);
    const location = useLocation();
    const { contactUSData, setContactUSData, wpNumber } = useMediaQueries()
    const navigate = useNavigate()

    const getContactUSData = async () => {
        try {
            const response = await getContactUS();
            setContactUSData(response?.contactUsData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getContactUSData();
    }, []);

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    const isActive = (path) => {
        if (path === "/") {
            return location.pathname === "/";
        }
        return location.pathname.startsWith(path);
    };

    const linkStyle = (path) => ({
        textDecoration: 'none',
        color: 'black',
        borderBottom: isActive(path) ? '2px solid #01A0E2' : 'none', // Underline for active link
        paddingBottom: '5px',
        width: 'fit-content'
    });

    return (
        <>
            <AppBar
                className="header"
                position="fixed"
                color="transparent"
                elevation={0}
                sx={{ py: 1, backgroundColor: '#fff' }}
            >
                <Container>
                    <Toolbar
                        sx={{
                            justifyContent: "space-between",
                            px: '0 !important',
                            cursor: 'pointer'
                        }}>
                        <Box data-aos="fade-down"
                            onClick={() => {
                                navigate("/");
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                        >
                            <img src={logo} alt="logo" style={{ height: "50px" }} />
                        </Box>

                        {isMobile ? (
                            <IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                                <AiOutlineMenu />
                            </IconButton>
                        ) : (
                            <>
                                <Box display="flex" gap={4} data-aos="fade-down">
                                    <Link to="/" style={linkStyle("/")}>
                                        HOME
                                    </Link>
                                    <Link to="/aboutus" style={linkStyle("/aboutus")}>
                                        ABOUT US
                                    </Link>
                                    <Link to="/product" style={linkStyle("/product")}>
                                        PRODUCTS
                                    </Link>
                                    <Link to="/contactus" style={linkStyle("/contactus")}>
                                        CONTACT US
                                    </Link>
                                </Box>

                                <Box display="flex" gap={2} data-aos="fade-down" alignItems={'center'}>
                                    <Box sx={{ color: "#01A0E2", cursor: 'pointer' }} onClick={() => window.open(`${contactUSData?.facebookLink}`)}>
                                        <LiaFacebookSquare style={{ fontSize: "2.2rem" }} />
                                    </Box>
                                    <Box sx={{ color: "#01A0E2", cursor: 'pointer' }} onClick={() => window.open(`https://wa.me/${wpNumber}`, '_blank')}>
                                        <PiWhatsappLogo style={{ fontSize: "1.8rem" }} />
                                    </Box>
                                    <Box sx={{ color: "#01A0E2", cursor: 'pointer' }} onClick={() => window.open(`tel:${contactUSData?.mobileNumber}`)}>
                                        <IoCallOutline style={{ fontSize: "1.8rem" }} />
                                    </Box>
                                    <Box sx={{ color: "#01A0E2", cursor: 'pointer' }} onClick={() => window.open(`${contactUSData?.instagramLink}`)}>
                                        <FaInstagram style={{ fontSize: "1.8rem" }} />
                                    </Box>
                                </Box>
                            </>
                        )}
                    </Toolbar>
                </Container>
            </AppBar>
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box
                    sx={{ width: 250 }}
                    role="presentation"
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}
                >
                    <Box
                        sx={{ textAlign: 'center', py: 2, cursor: 'pointer' }}
                        onClick={() => {
                            navigate("/");
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                    >
                        <img src={logo} alt="logo" style={{ height: "40px" }} />
                    </Box>
                    <Box display="flex" flexDirection="column" sx={{ py: 2, pl: 6, pr: 2 }} gap={2} justifyContent={'center'}>
                        <Link to="/" style={linkStyle("/")}>
                            HOME
                        </Link>
                        <Link to="/aboutus" style={linkStyle("/aboutus")}>
                            ABOUT US
                        </Link>
                        <Link to="/product" style={linkStyle("/product")}>
                            PRODUCTS
                        </Link>
                        <Link to="/contactus" style={linkStyle("/contactus")}>
                            CONTACT US
                        </Link>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                            <Box sx={{ color: "#01A0E2" }} onClick={() => window.open(`${contactUSData?.facebookLink}`)}>
                                <LiaFacebookSquare style={{ fontSize: "2.2rem" }} />
                            </Box>
                            <Box sx={{ color: "#01A0E2" }} onClick={() => window.open(`https://wa.me/${wpNumber}`, '_blank')}>
                                <PiWhatsappLogo style={{ fontSize: "1.8rem" }} />
                            </Box>
                            <Box sx={{ color: "#01A0E2" }} onClick={() => window.open(`tel:${contactUSData?.mobileNumber}`)}>
                                <IoCallOutline style={{ fontSize: "1.8rem" }} />
                            </Box>
                            <Box sx={{ color: "#01A0E2" }} onClick={() => window.open(`${contactUSData?.instagramLink}`)}>
                                <FaInstagram style={{ fontSize: "1.8rem" }} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Drawer>
        </>
    );
};

export default Header;